<script lang="ts">
	import MultiplePageLayout from "@hitit/hub/src/layouts/MultiplePageLayout.svelte";
	import ManageStoreItem from "./ManageStoreItem.svelte";
	import ManageOptions from "./ManageOptions.svelte";
	import ContainerLoading from "../components/common/ContainerLoading.svelte";
	import { navigate, Router, Route } from "svelte-routing";

	import { popup, saveStatus } from "../store";
	import { t } from "../../stores";
	import { onDestroy } from "svelte";

	export let storeId = "";
	export let editable = true;

	const headerInfos = [
		{
			title: $t("global.product.Manage_Item"),
			clickEvent: () => navigate("/product/item"),
			route: "/product/item/*",
		},
		{
			title: $t("global.product.Manage_Option"),
			clickEvent: () => navigate("/product/option"),
			route: "/product/option/*",
		},
	];
	onDestroy(() => {
		$popup = undefined;
	});

</script>

<MultiplePageLayout headerInfos={headerInfos}>
	{#if $saveStatus.options || $saveStatus.storeItems}
		<ContainerLoading>
			<p>{$t('global.saving_changes')}</p>
		</ContainerLoading>
	{/if}
	<Router>
		<Route path="/item">
			<ManageStoreItem storeId={storeId} editable={editable} />
		</Route>
		<Route path="/option">
			<ManageOptions storeId={storeId} editable={editable} />
		</Route>
	</Router>
</MultiplePageLayout>

<style lang="scss">
	p {
		font-size: 1.25rem;
		color: #46474b;
	}

</style>
